import { useState } from "react";
import DashboardLogin from "./DashboardLogin";

const C = {
  bg0: "#020913",
  bg1: "#040f1e",
  blue: "#00a2ff",
  blueDark: "#0062cc",
  text: "#e2edf7",
  muted: "#7a9ab5",
  border: "rgba(0,162,255,0.14)",
  cardBg: "rgba(6,21,41,0.85)",
  red: "#e53935",
};

const EMPTY_JOB = {
  title: "",
  type: "Full-time",
  date: "",
  desc: "",
  requirements: "",
  status: "active",
  featured: false,
};

export default function JobsDashboard() {
  const [auth, setAuth] = useState(
    localStorage.getItem("dashboard_auth") === "true"
  );
  const [jobs, setJobs] = useState([
    { id: 1, title: "Network Engineer", type: "Full-time", date: "2025-01-01", desc: "Manage enterprise networks.", requirements: "3+ years experience", status: "active", featured: true },
    { id: 2, title: "IT Support Specialist", type: "Part-time", date: "2025-01-15", desc: "Provide technical support.", requirements: "1+ year experience", status: "active", featured: false },
  ]);
  const [form, setForm] = useState(EMPTY_JOB);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  if (!auth) return <DashboardLogin onLogin={() => setAuth(true)} />;

  const handleSave = () => {
    if (!form.title || !form.date || !form.desc) {
      alert("Please fill all required fields!");
      return;
    }
    if (editId !== null) {
      setJobs(jobs.map(j => j.id === editId ? { ...form, id: editId } : j));
      setEditId(null);
    } else {
      setJobs([...jobs, { ...form, id: Date.now() }]);
    }
    setForm(EMPTY_JOB);
    setShowForm(false);
  };

  const handleEdit = (job) => {
    setForm(job);
    setEditId(job.id);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("Delete this job?")) {
      setJobs(jobs.filter(j => j.id !== id));
    }
  };

  const inputStyle = {
    width: "100%", padding: "10px 14px",
    background: "rgba(0,162,255,0.05)",
    border: `1px solid ${C.border}`,
    borderRadius: 8, color: C.text,
    fontSize: 14, outline: "none",
  };

  return (
    <div style={{ minHeight: "100vh", background: C.bg0, padding: "100px 32px 40px 32px", fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 32 }}>
        <div>
          <h1 style={{ color: C.text, fontSize: 28, fontWeight: 800, margin: 0 }}>Jobs Dashboard</h1>
          <p style={{ color: C.muted, marginTop: 4 }}>{jobs.length} job(s) total</p>
        </div>
        <button onClick={() => { setForm(EMPTY_JOB); setEditId(null); setShowForm(true); }} style={{
          background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`,
          color: "#fff", border: "none", borderRadius: 8,
          padding: "10px 24px", fontSize: 14, fontWeight: 600, cursor: "pointer",
        }}>+ Add New Job</button>
      </div>

      {showForm && (
        <div style={{ background: C.cardBg, border: `1px solid ${C.border}`, borderRadius: 14, padding: 28, marginBottom: 32 }}>
          <h2 style={{ color: C.text, marginBottom: 20, fontSize: 18 }}>{editId ? "Edit Job" : "Add New Job"}</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label style={{ color: C.muted, fontSize: 13 }}>Job Title *</label>
              <input style={inputStyle} value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="e.g. Network Engineer" />
            </div>
            <div>
              <label style={{ color: C.muted, fontSize: 13 }}>Type</label>
              <select style={inputStyle} value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                <option>Full-time</option>
                <option>Part-time</option>
                <option>Contract</option>
                <option>Internship</option>
              </select>
            </div>
            <div>
              <label style={{ color: C.muted, fontSize: 13 }}>Date *</label>
              <input style={inputStyle} type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} />
            </div>
            <div>
              <label style={{ color: C.muted, fontSize: 13 }}>Status</label>
              <select style={inputStyle} value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                <option value="active">Active</option>
                <option value="expired">Expired</option>
              </select>
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={{ color: C.muted, fontSize: 13 }}>Description *</label>
              <textarea style={{ ...inputStyle, height: 80, resize: "vertical" }} value={form.desc} onChange={e => setForm({ ...form, desc: e.target.value })} placeholder="Job description..." />
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={{ color: C.muted, fontSize: 13 }}>Requirements</label>
              <textarea style={{ ...inputStyle, height: 80, resize: "vertical" }} value={form.requirements} onChange={e => setForm({ ...form, requirements: e.target.value })} placeholder="Job requirements..." />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input type="checkbox" id="featured" checked={form.featured} onChange={e => setForm({ ...form, featured: e.target.checked })} />
              <label htmlFor="featured" style={{ color: C.muted, fontSize: 13 }}>Featured Job</label>
            </div>
          </div>
          <div style={{ display: "flex", gap: 12, marginTop: 20 }}>
            <button onClick={handleSave} style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", border: "none", borderRadius: 8, padding: "10px 28px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
              {editId ? "Save Changes" : "Add Job"}
            </button>
            <button onClick={() => { setShowForm(false); setForm(EMPTY_JOB); setEditId(null); }} style={{ background: "transparent", color: C.muted, border: `1px solid ${C.border}`, borderRadius: 8, padding: "10px 28px", fontSize: 14, cursor: "pointer" }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {jobs.map(job => (
          <div key={job.id} style={{ background: C.cardBg, border: `1px solid ${C.border}`, borderRadius: 14, padding: "20px 28px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
                <h3 style={{ color: C.text, fontSize: 17, fontWeight: 700, margin: 0 }}>{job.title}</h3>
                {job.featured && <span style={{ background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`, color: "#fff", fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 100 }}>Featured</span>}
                <span style={{ background: job.status === "active" ? "rgba(0,200,100,0.1)" : "rgba(229,57,53,0.1)", color: job.status === "active" ? "#00c864" : C.red, fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 100, border: `1px solid ${job.status === "active" ? "rgba(0,200,100,0.3)" : "rgba(229,57,53,0.3)"}` }}>
                  {job.status === "active" ? "Active" : "Expired"}
                </span>
              </div>
              <p style={{ color: C.muted, fontSize: 13, margin: 0 }}>{job.type} · {job.date}</p>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={() => handleEdit(job)} style={{ background: "rgba(0,162,255,0.1)", color: C.blue, border: `1px solid rgba(0,162,255,0.2)`, borderRadius: 8, padding: "8px 20px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Edit</button>
              <button onClick={() => handleDelete(job.id)} style={{ background: "rgba(229,57,53,0.1)", color: C.red, border: "1px solid rgba(229,57,53,0.2)", borderRadius: 8, padding: "8px 20px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}